import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Attach admin token if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("dsa_admin_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && window.location.pathname.startsWith("/admin/")) {
      localStorage.removeItem("dsa_admin_token");
      window.location.href = "/admin";
    }
    return Promise.reject(err);
  },
);

export const originUrl = () => window.location.origin;

export const kindLabel = (t) =>
  ({
    convoyage: "Convoyage de véhicule",
    vtc_trip: "Trajet VTC",
    vtc_dispo: "Mise à disposition VTC",
    cleaning: "Nettoyage automobile",
  })[t] || t;

export const statusLabel = (s) =>
  ({
    pending_payment: "En attente de paiement",
    awaiting_validation: "À valider",
    confirmed: "Confirmée",
    refused: "Refusée",
    in_progress: "En cours",
    completed: "Terminée",
    cancelled: "Annulée",
  })[s] || s;

export const eur = (v) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(v ?? 0);
